<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()!"
	[initialIndex]="currentIndex()!"
	(navigation)="onNavigate($event)"
></lvr-nav-carousel>

<lvr-heading
	[showEditButton]="canEditLek()"
	[disableEditButton]="disableEditLekButton()"
	(editClicked)="openEdit()"
	[showDeleteButton]="canDeleteLek()"
	[deleteTranslationKey]="'base.button.delete'"
	[disableDeleteButton]="disableDeleteLekButton()"
	(deleteClicked)="removeLek(lek()!.id)"
>
	{{
		client()
			? ('lek.details.title'
				| transloco
					: {
							lastName: client()?.value?.name,
							firstName: client()?.value?.firstName,
							birthdate: (client()?.value?.dateOfBirth | date: 'dd.MM.yyyy'),
					  })
			: ''
	}}
</lvr-heading>

@if (lek(); as lek) {
	<table>
		<!-- Took place on / Contact type -->
		<tr>
			<th scope="col">{{ 'lek.details.start' | transloco }}</th>
			<th scope="col">{{ 'lek.details.end' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ lek.startDate ? (lek.startDate | date: dateDisplayFormat) : '-' }}</td>
			<td>{{ lek.endDate ? (lek.endDate | date: dateDisplayFormat) : '-' }}</td>
		</tr>
		<tr>
			<th scope="col">{{ 'lek.details.performance' | transloco }}</th>
			<th scope="col">{{ 'lek.details.result' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ lek.categoryAssistance.description }}</td>
			<td>{{ lek.result }}</td>
		</tr>
		<tr>
			<th scope="col">{{ 'lek.details.sponsor' | transloco }}</th>
			<th scope="col">{{ 'lek.details.workplace' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ lek.sponsor?.name ?? '-' }}</td>
			<td>{{ lek.workplace?.institutionBranch?.name || '-' }}</td>
		</tr>
		<tr>
			<th scope="col">{{ 'lek.details.external_sponsor' | transloco }}</th>
			<th scope="col">Tätigkeit:</th>
		</tr>
		<tr>
			<td>
				{{
					lek.isHandledByExternalSponsor === undefined
						? '-'
						: lek.isHandledByExternalSponsor
							? ('lek.details.external_sponsor_yes' | transloco)
							: ('lek.details.external_sponsor_no' | transloco)
				}}
			</td>
			<td>{{ lek.workplace?.occupationTitle || '-' }}</td>
		</tr>
	</table>
}
